import React from "react";
// import "./BasicEmb.css"; // optional: add if you want custom styles

export default function BasicEmb() {
  return (
    <section className="embroidery-services page-center padding40tb">

      {/* HEADER */}
      <header>
        <h2>Embroidery Services</h2>
        <p>
          From caps and bags to polos, luggage, and beach towels, we can embroider it all! Whether you need a small run or a large order, tiny lettering or bold appliques, we bring precision and pride to every stitch.
        </p>
        <p>
          <a href="#stp">Embroidery: The Process</a><br />
          <a href="#ar">Art Requirements</a><br />
          <a href="#et">Embroidery Terms</a><br />
          {/* <a href="#hft">Stitch &amp; Thread Types</a> */}
        </p>
      </header>

      {/* THE PROCESS */}
      <div id="stp">
        <h3>The Process</h3>
        <p>
          From the moment you submit your order to the time it’s carefully packaged, we follow a series of steps to ensure top-quality embroidery.
        </p>
        <ul>
          <li>Review Art Submission</li>
          <li>Art Proof</li>
          <li>Color Separation and Film Output</li>
          <li>Pre-Press Meeting</li>
          <li>Screen Exposure</li>
          <li>Screen Prep for Production</li>
          <li>Mixing Ink</li>
          <li>Set Up</li>
        </ul>

        <article>
          <h4>Review Art Submission</h4>
          <p>
            We examine fine details, gradients, and lettering to ensure your design will embroider clearly. If adjustments are needed, we provide expert recommendations for optimal results on every garment.
          </p>
        </article>

        <article>
          <h4>Digitizing</h4>
          <p>
            Digitizing transforms your digital artwork into precise stitch patterns using specialized software. Each stitch is mapped virtually for the embroidery machine.
          </p>
        </article>

        <article>
          <h4>Sew Out</h4>
          <p>
            Before full production, we create a sample stitch-out to verify accuracy. Any necessary adjustments are made, and the final sample is shared for your approval.
          </p>
        </article>

        <article>
          <h4>Hooping &amp; Clamping</h4>
          <p>
            Garments are stabilized using embroidery hoops attached to the machine heads, ensuring precise and consistent stitching.
          </p>
        </article>

        <article>
          <h4>Run The Lines</h4>
          <p>
            Our 15-head machines allow us to produce multiple garments simultaneously. For orders over 15 pieces, we run them in consecutive "lines" of 15 items.
          </p>
        </article>

        <article>
          <h4>Trimming</h4>
          <p>
            After stitching, excess backing is removed from each garment—either by tearing or cutting, depending on the type of backing used.
          </p>
        </article>

        <article>
          <h4>Steaming</h4>
          <p>
            Hoops can leave temporary imprints on fabric. We steam garments to restore a smooth, pristine finish.
          </p>
        </article>

        <article>
          <h4>Folding &amp; Bagging</h4>
          <p>
            Each embroidered garment is carefully folded and bagged to ensure it reaches you in perfect condition.
          </p>
        </article>
      </div>

      {/* ART REQUIREMENTS */}
      <div id="ar">
        <h3>Art Requirements</h3>
        <p>
          All artwork is converted into digital stitch files. Clean, high-quality vector files produce the best embroidery results.
        </p>
        <ul>
          <li style={{ color: "#c43235" }}>
            Indicate the fabric type when submitting your logo—different fabrics affect how embroidery looks.
          </li>
          <li style={{ color: "#c43235" }}>
            Adobe Illustrator vector files are preferred for optimal clarity.
          </li>
          <li style={{ color: "#c43235" }}>
            Smallest letter height should be at least 1/4”.
          </li>
          <li style={{ color: "#c43235" }}>
            Fine details and thin lettering may not work well on thick or textured fabrics.
          </li>
        </ul>
      </div>

      {/* EMBROIDERY TERMS */}
      <section id="et">
        <h3>Embroidery Terms</h3>

        <article>
          <h4>Digitizing</h4>
          <p>
            Converts artwork into precise stitch patterns for the machine, determining stitch placement and thread colors.
          </p>
        </article>

        <article>
          <h4>Backing</h4>
          <p>
            Stiff material added inside the garment stabilizes stitches. Three types are used:
          </p>
          <p>
            <strong style={{ color: "#c43235" }}>Tear Away Backing</strong> — quick and easy; ideal for sturdy items like caps, shirts, and backpacks.
          </p>
          <p>
            <strong style={{ color: "#c43235" }}>Cut Away Backing</strong> — used on softer fabrics to prevent distortion; perfect for knit materials such as pique.
          </p>
          <p>
            <strong style={{ color: "#c43235" }}>Fabric Backing</strong> — premium, barely visible backing for delicate or light-colored fabrics; available at extra cost.
          </p>
        </article>

        <article>
          <h4>Solvy Topping</h4>
          <p>
            
            A temporary layer applied to high-pile fabrics like fleece, hoodies, and towels to ensure designs remain clear and visible.
          </p>
        </article>
      </section>

      {/* NAVIGATION LINKS */}
      <p>
        <a href="#stp">Embroidery: The Process</a><br />
        <a href="/art-requirements">Art Requirements</a><br />
        <a href="/emb-specialties">Embroidery Specialties</a><br />
        <a href="/stitch-type">Stitch Types</a><br />
        <a href="/thread-type">Thread Types</a>
      </p>

    </section>
  );
}
